import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { ConversationContentCard } from 'common/store/genesys-cloud/conversations/messages/models/message-data.model';

@Component({
  selector: 'app-genesys-chat-message-card',
  templateUrl: './genesys-chat-message-card.component.html',
  styleUrls: ['./genesys-chat-message-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenesysChatMessageCardComponent {
  @Input() card: ConversationContentCard;
}
